export default __webpack_public_path__ + "static/media/330_private01-jp-mobile.769cfd8f.png";